/**
 * base64url → bytes.
 *
 * **O navegador exige isto, e não aceita a string.** `pushManager.subscribe`
 * recebe `applicationServerKey` como `Uint8Array` (ou `ArrayBuffer`); passar a
 * chave em texto é o erro mais comum de quem liga Web Push pela primeira vez, e
 * ele aparece como `InvalidCharacterError` sem dizer o porquê.
 *
 * `atob` só entende base64 **comum**, então os três ajustes abaixo não são
 * cosméticos: `-` e `_` são os caracteres que o base64url troca, e o padding
 * `=` foi removido na geração.
 */
export function base64UrlToBytes(base64url: string): Uint8Array<ArrayBuffer> {
  const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/')
  const comPadding = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
  const binario = atob(comPadding)
  // **`ArrayBuffer` explícito, e o tipo de retorno diz isso.** Sem ele o TS
  // infere `Uint8Array<ArrayBufferLike>`, que **não** é atribuível ao
  // `BufferSource` do `applicationServerKey` — `ArrayBufferLike` inclui
  // `SharedArrayBuffer`, que a API não aceita. O erro aparece na chamada, longe
  // daqui, e some com um `as` que esconderia o motivo.
  const bytes = new Uint8Array(new ArrayBuffer(binario.length))
  for (let i = 0; i < binario.length; i += 1) bytes[i] = binario.charCodeAt(i)
  return bytes
}
